<template>
  <div class="SchoolsPayments">
    <h1 class="text-center my-7">میزان فروش</h1>
    <v-row>
      <v-col cols="12" md="3" class="px-2">
        <Navigation />
      </v-col>
      <v-col cols="12" md="9" class="px-2">
        <v-alert type="info">
          به صورت پیش فرض اطلاعات تا یک هفته قبل نمایش داده می شود
        </v-alert>
        <v-row>
          <v-col cols="12" md="4">
            <v-text-field
              id="pStartDate"
              label="تاریخ شروع"
              v-model="pStartDate"
              hide-details="auto"
            />

            <date-picker
              v-model="pStartDate"
              :auto-submit="true"
              format="jYYYY/jMM/jDD"
              element="pStartDate"
              alt-name="startDate"
              alt-format="YYYY-MM-DD HH:mm:ss"
            />
          </v-col>
          <v-col cols="12" md="4">
            <v-text-field
              id="pEndDate"
              label="تاریخ پایان"
              v-model="pEndDate"
              hide-details="auto"
            />

            <date-picker
              v-model="pEndDate"
              :auto-submit="true"
              format="jYYYY/jMM/jDD"
              element="pEndDate"
              alt-name="endDate"
              alt-format="YYYY-MM-DD HH:mm:ss"
            />
          </v-col>
          <v-col cols="12" md="4" class="d-flex align-center">
            <v-btn depressed block color="primary" @click="updateData">
              جستجو
            </v-btn>
          </v-col>
          <v-col cols="12">
            <h3 class="mb-3">خرید کتاب</h3>
            <v-card class="pa-3">
              <div class="d-flex align-center">
                <v-text-field
                  v-model="search"
                  append-icon="mdi-magnify"
                  label="جستجو"
                  single-line
                  hide-details
                  class="mb-3"
                ></v-text-field>
                <v-alert
                  dense
                  outlined
                  type="success"
                  class="text-center mr-5 mb-0"
                >
                  جمع فروش:
                  <number
                    v-if="paymentsSum"
                    :number="paymentsSum.sum"
                    unit="تومان"
                  ></number>
                </v-alert>
              </div>
              <v-data-table
                :headers="userHeaders"
                :items="userPayments"
                :items-per-page="5"
                :search="search"
                :loading="loading"
                loading-text="دارم آماده ش میکنم ... صبر کن -_-"
              >
                <template v-slot:[`item.totalAmount`]="{ item }">
                  <number :number="item.totalAmount"></number>
                </template>
                <template v-slot:[`item.verifyDateTime`]="{ item }">
                  <persian-date :date="item.verifyDateTime" />
                </template>
              </v-data-table>
            </v-card>
          </v-col>
          <v-col cols="12">
            <h3 class="mb-3">لیست خرید های با تخفیف (100)</h3>
            <v-card class="pa-3">
              <v-text-field
                v-model="searchFree"
                append-icon="mdi-magnify"
                label="جستجو"
                single-line
                hide-details
                class="mb-3"
              ></v-text-field>
              <v-data-table
                :headers="userZeroHeaders"
                :items="userZeroPayments"
                :items-per-page="5"
                :search="searchFree"
                :loading="loading"
                loading-text="دارم آماده ش میکنم ... صبر کن -_-"
              >
                <template v-slot:[`item.verifyDateTime`]="{ item }">
                  <persian-date :date="item.verifyDateTime" />
                </template>
              </v-data-table>
            </v-card>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </div>
</template>
<script>
import Navigation from "../_Navigation.vue";

export default {
  name: "schools-payments-component",
  components: {
    Navigation
  },
  data() {
    return {
      loading: true,
      pStartDate: "",
      pEndDate: "",
      pbirthday: "",
      paymentsSum: 0,
      userPayments: [],
      userHeaders: [
        { text: "نام مدرسه", value: "title", align: "center" },
        { text: "مدیر", value: "moderator", align: "center" },
        { text: "استان", value: "state", align: "center" },
        { text: "رابط", value: "coordinator", align: "center" },
        { text: "شماره تماس", value: "mobilenumber", align: "center" },
        { text: "نمایندگی", value: "agent", align: "center" },
        { text: "تاریخ خرید", value: "verifyDateTime", align: "center" },
        { text: "قیمت پرداختی", value: "totalAmount", align: "center" }
      ],
      search: "",
      userZeroPayments: [],
      userZeroHeaders: [
        { text: "نام مدرسه", value: "title", align: "center" },
        { text: "مدیر", value: "moderator", align: "center" },
        { text: "استان", value: "state", align: "center" },
        { text: "رابط", value: "coordinator", align: "center" },
        { text: "شماره تماس", value: "mobilenumber", align: "center" },
        { text: "نمایندگی", value: "agent", align: "center" },
        { text: "تاریخ خرید", value: "verifyDateTime", align: "center" }
      ],
      searchFree: ""
    };
  },
  created() {
    this.getData();
  },
  methods: {
    getData() {
      this.loading = true;
      this.$api.post("/schoolPayments").then((res) => {
        this.userPayments = res.data.userPayments;
        this.userZeroPayments = res.data.userZeroPayments;
        this.paymentsSum = res.data.paymentsSum[0];
        this.loading = false;
      });
    },
    updateData() {
      const startDate = document.getElementsByName("startDate")[0].value;
      const endDate = document.getElementsByName("endDate")[0].value;
      this.loading = true;
      this.$api
        .post("/schoolPayments", {
          startDate: startDate,
          endDate: endDate
        })
        .then((res) => {
          this.paymentsSum = res.data.paymentsSum[0];
          this.userPayments = res.data.userPayments;
          this.userZeroPayments = res.data.userZeroPayments;
          this.loading = false;
        });
    }
  }
};
</script>

<style>
.vpd-container {
  top: 10% !important;
  -webkit-transform: translate(-50%, -10%) !important;
  transform: translate(-50%, -10%) !important;
}
</style>
